import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ServerErrorState {
  hasError: boolean;
  isPermissionsError: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ServerErrorService {
  private errorState = new BehaviorSubject<ServerErrorState>({
    hasError: false,
    isPermissionsError: false
  });

  public errorState$ = this.errorState.asObservable();

  setServerError(isPermissionsError = false): void {
    this.errorState.next({
      hasError: true,
      isPermissionsError
    });
  }

  clearServerError(): void {
    this.errorState.next({
      hasError: false,
      isPermissionsError: false
    });
  }

  getCurrentErrorState(): ServerErrorState {
    return this.errorState.value;
  }

  hasServerError(): boolean {
    return this.errorState.value.hasError;
  }
}
